import { useEffect, useState } from "react";
import api, { formatCLP } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Receipt } from "@phosphor-icons/react";

const statusMap = {
  paid: { label: "Pagada", cls: "bg-primary text-white" },
  pending: { label: "Pendiente", cls: "bg-accent text-white" },
  cancelled: { label: "Cancelada", cls: "bg-destructive text-white" },
};

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)).catch(() => {}); }, []);
  const fmt = (d) => new Date(d).toLocaleString("es-CL", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

  return (
    <div>
      <h1 className="font-display text-3xl font-800 tracking-tight mb-1">Mis Compras</h1>
      <p className="text-muted-foreground mb-8">Historial de órdenes y su estado.</p>
      {orders.length === 0 ? (
        <div className="bg-white border border-border rounded-lg p-12 text-center" data-testid="orders-empty">
          <Receipt size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">No tienes compras registradas.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => {
            const st = statusMap[o.status] || statusMap.pending;
            return (
              <div key={o.id} className="bg-white border border-border rounded-lg p-6" data-testid={`order-${o.id}`}>
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <span className="font-mono text-sm text-muted-foreground">#{o.id.slice(0, 8).toUpperCase()}</span>
                    <p className="text-xs text-muted-foreground">{fmt(o.created_at)}</p>
                  </div>
                  <Badge className={st.cls}>{st.label}</Badge>
                </div>
                <div className="space-y-1 border-t border-border pt-3">
                  {o.items.map((it) => (
                    <div key={it.course_id} className="flex justify-between text-sm">
                      <span className="text-muted-foreground">{it.title}</span>
                      <span>{formatCLP(it.price)}</span>
                    </div>
                  ))}
                </div>
                <div className="flex justify-between mt-3 pt-3 border-t border-border">
                  {o.discount > 0 && <span className="text-sm text-accent">Descuento {formatCLP(o.discount)}</span>}
                  <span className="font-display font-800 ml-auto">Total {formatCLP(o.total)}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
